<template>
    <info-container class="info-container" ref="info-container">
        <h2>NOTIFICATIONS</h2>
        <template>
            <h3>Get informed by mail when:</h3>
            <el-checkbox v-model="newAvailableFeed" label="A new feed is available"></el-checkbox>
            <el-checkbox v-model="checkStartingFeed" label="A feed is going to start"></el-checkbox>
            <el-checkbox v-model="checkFeedEndDateChange" label="A Feed end date has changed"></el-checkbox>
            <div class="actions">
                <el-button class="save-button" type="text" @click="saveNewNotifConf">Edit</el-button>
            </div>
        </template>
    </info-container>
</template>

<script>
import InfoContainer from '../../partials/global-view-info-container.vue';
import {mapGetters} from 'vuex';

export default {

    components: {
        InfoContainer
    },

    props: {

    },

    data: function(){
        return {
            checkStartingFeed: false,
            newAvailableFeed: false,
            checkFeedEndDateChange: false,
        };
    },

    computed: {
        ...mapGetters([
            'currentUser'
        ])
    },

    mounted: function(){
        this.checkStartingFeed = this.currentUser.notif_parameters.feed_starting_soon || false;
        this.newAvailableFeed = this.currentUser.notif_parameters.new_available_feed || false;
        this.checkFeedEndDateChange = this.currentUser.notif_parameters.feed_end_date_changed || false;
        this.$refs['info-container'].disableLoading();
    },

    methods: {
        saveNewNotifConf() {
            this.$store.dispatch('patchItem', {
                item: {
                    url: this.currentUser.url,
                    notif_parameters: {
                        feed_starting_soon: this.checkStartingFeed,
                        feed_end_date_changed: this.checkFeedEndDateChange,
                        new_available_feed: this.newAvailableFeed
                    }
                },
                model: 'selfUser'
            }).then(() => {
                this.$message({
                    message: 'Successfully changed your notification parameters',
                    type: 'success'
                });
            }).catch(() => {
                this.$message({
                    message: 'Error encountered when changing your notification parameters',
                    type: 'error'
                });
            });
        }
    },
};
</script>

<style lang="scss">
.info-container {
    margin-top: 87px !important;
    h2 {
        margin-bottom: 30px;
    }
    h3 {
        font-size: 9px;
        text-transform: uppercase;
        margin-bottom: 25px;
    }
    .el-checkbox {
        margin-bottom: 15px;
        .el-checkbox__label {
            font-size: 12px;
            color: #BBBBBB;
        }
        .el-checkbox__inner {
            border: 1px solid #BBBBBB;
            background-color: unset;
        }
        &.is-checked {
            .el-checkbox__label {
                color: #409EFF;
            }
            .el-checkbox__inner {
                border: 1px solid #409EFF;
                background-color: #409EFF;
            }

        }
    }
    .actions {
        margin-top: 55px;
        float: right;
        .cancel-button {
            width: 50px;
            height: 30px;
            color: #BBBBBB;
            padding: 0;
        }
        .save-button {
            width: 50px;
            height: 30px;
            background: #BBBBBB;
            border-radius: 2px;
            padding: 0;
            color: #444444;
            font-size: 12px;
            &:hover {
                background: #00A3FF;
                color: #FFFFFF;
            }

        }

    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Profile/notification-section.vue